import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { useAuth } from '../context/AuthContext';

export default function AdminPanel() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (!user || user.email !== 'agentjack1244@gmail.com') { navigate('/dashboard'); return; }
    api.getAdminStats().then(setStats).catch(() => {});
    api.getAdminSubscribers().then(setUsers).catch(() => {});
  }, []);

  if (!user || user.email !== 'agentjack1244@gmail.com') return null;

  const filtered = users.filter(u =>
    (u.name && u.name.toLowerCase().includes(search.toLowerCase())) ||
    (u.email && u.email.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* Stats */}
      {stats && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12 }}>
          {[
            { label: "Subscribers", value: stats.totalUsers, color: "#534AB7" },
            { label: "MRR", value: "$" + (stats.mrr || 0), color: "#1D9E75" },
            { label: "Total leads", value: stats.totalLeads, color: "#378ADD" },
            { label: "Messages sent", value: stats.totalMessages, color: "#D85A30" },
          ].map(s => (
            <div key={s.label} style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.2)", padding: "20px", boxShadow: "0 0 20px rgba(83,74,183,0.05)" }}>
              <div style={{ fontSize: 11, fontWeight: 600, color: "var(--text2)", marginBottom: 10, textTransform: "uppercase", letterSpacing: "0.5px" }}>{s.label}</div>
              <div style={{ fontSize: 36, fontWeight: 700, color: s.color, lineHeight: 1 }}>{s.value}</div>
            </div>
          ))}
        </div>
      )}

      {/* Subscribers table */}
      <div style={{ background: "var(--bg2)", borderRadius: 16, border: "0.5px solid rgba(83,74,183,0.3)", overflow: "hidden", boxShadow: "0 0 30px rgba(83,74,183,0.08)" }}>
        <div style={{ padding: "14px 20px", borderBottom: "0.5px solid var(--border)", background: "linear-gradient(135deg,rgba(83,74,183,0.08),rgba(29,158,117,0.06))", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#534AB7", boxShadow: "0 0 8px #534AB7" }} />
            <span style={{ fontSize: 13, fontWeight: 700, color: "var(--text)" }}>Subscribers</span>
          </div>
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search..." style={{ padding: "7px 12px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 12, color: "var(--text)", width: 200 }} />
        </div>
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "var(--bg3)" }}>
                {["Name", "Email", "Plan", "Leads", "Messages", "Joined", "Actions"].map(h => (
                  <th key={h} style={{ padding: "10px 16px", textAlign: "left", fontSize: 11, fontWeight: 600, color: "var(--text2)", textTransform: "uppercase", letterSpacing: "0.5px" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u._id} style={{ borderBottom: "0.5px solid var(--border)", transition: "background 0.1s" }}
                  onMouseEnter={e => e.currentTarget.style.background = "var(--bg3)"}
                  onMouseLeave={e => e.currentTarget.style.background = "transparent"}>
                  <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 600, color: "var(--text)" }}>{u.name || "—"}</td>
                  <td style={{ padding: "12px 16px", fontSize: 12, color: "var(--text2)" }}>{u.email}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <select value={u.plan} onChange={async e => { await api.updateSubscriber(u._id, { plan: e.target.value }); setUsers(us => us.map(x => x._id === u._id ? { ...x, plan: e.target.value } : x)); }}
                      style={{ padding: "5px 10px", borderRadius: 8, border: "0.5px solid var(--border2)", background: "var(--bg3)", fontSize: 11, color: "var(--text)", cursor: "pointer" }}>
                      {["Basic", "Pro", "Pro+"].map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                  </td>
                  <td style={{ padding: "12px 16px", fontSize: 12, color: "var(--text2)" }}>{u.leadCount || 0}</td>
                  <td style={{ padding: "12px 16px", fontSize: 12, color: "var(--text2)" }}>{u.messageCount || 0}</td>
                  <td style={{ padding: "12px 16px", fontSize: 12, color: "var(--text2)" }}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td>
                  <td style={{ padding: "12px 16px" }}>
                    <button onClick={async () => { if (window.confirm('Delete account?')) { await api.deleteSubscriber(u._id); setUsers(us => us.filter(x => x._id !== u._id)); } }}
                      style={{ padding: "5px 12px", borderRadius: 7, border: "0.5px solid rgba(240,149,149,0.5)", background: "transparent", fontSize: 11, cursor: "pointer", color: "#A32D2D" }}>Delete</button>
                  </td>
                </tr>
              ))}
              {filtered.length === 0 && (
                <tr><td colSpan={7} style={{ padding: "40px", textAlign: "center", color: "var(--text3)", fontSize: 13 }}>No subscribers yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
